export default "__VITE_ASSET__D7CAGZU8__"